<template>
    <div>
        <v-progress-circular
            v-if="loading"
            indeterminate
            size="24"
            width="3"
        ></v-progress-circular>
        <span v-else-if="tooltip && tooltip.length">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <span v-on="on">{{ value }}</span>
                </template>
                <div>
                    <div
                        v-for="(item, index) in tooltipLines"
                        :key="`tt-item-${index}`"
                    >
                        {{ item }}
                    </div>
                </div>
            </v-tooltip>
        </span>
        <span v-else>{{ value }}</span>
    </div>
</template>

<script>
import { VTooltip, VProgressCircular } from 'vuetify/lib';

export default {
    name: 'VLabelField',
    components: {
        'v-tooltip': VTooltip,
        'v-progress-circular': VProgressCircular
    },
    props: {
        value: {
            type: null,
            required: false,
            default: ''
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: [String, Array],
            required: false,
            default: ''
        }
    },
    computed: {
        tooltipLines() {
            let tooltips = [];
            if (Array.isArray(this.tooltip)) {
                tooltips = [...this.tooltip];
            } else {
                tooltips = [this.tooltip];
            }
            return tooltips;
        }
    }
};
</script>

<style></style>
